module.exports = __webpack_public_path__ + "static/media/v4m.ea23d240.mp4";